/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AgeData } from './AgeData';
import {
    AgeDataFromJSON,
    AgeDataFromJSONTyped,
    AgeDataToJSON,
} from './AgeData';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface AgeDataGet200Response
 */
export interface AgeDataGet200Response {
    /**
     * 
     * @type {Array<AgeData>}
     * @memberof AgeDataGet200Response
     */
    data?: Array<AgeData>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof AgeDataGet200Response
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the AgeDataGet200Response interface.
 */
export function instanceOfAgeDataGet200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AgeDataGet200ResponseFromJSON(json: any): AgeDataGet200Response {
    return AgeDataGet200ResponseFromJSONTyped(json, false);
}

export function AgeDataGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgeDataGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(AgeDataFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function AgeDataGet200ResponseToJSON(value?: AgeDataGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(AgeDataToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

